import { useForm } from 'react-hook-form';
import { SEARCH_FORM, searchDefaultValues } from '../form';
import { exportHeaders, exportBlankFields } from '../columns';
import { useGetClaimFull } from './useGetClaimFull';
import { useGetClaimDate } from './useGetClaimDate';
import { useTable } from '../../../../components/table/hooks';
import { useCallback, useEffect, useState } from 'react';
import { useApproveClaim } from './useApproveClaim';
import { useDownloadShipment } from './useDownloadShipment';
import { useModal } from '../../../../components/modal/hooks/useModal';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';

export const useGetClaimList = ({ selectedRowKeys }) => {
  const [searchType, setSearchType] = useState(null);
  const [claimData, setClaimData] = useState(null);
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const { open: openProcessStatus, onToggle: onToggleProcessStatus } = useModal();
  const { open: openTracking, onToggle: onToggleTracking } = useModal();
  const { open: openLine, onToggle: onToggleLine } = useModal();
  const { open: openRemark, onToggle: onToggleRemark } = useModal();
  const formSearchObj = useForm({ defaultValues: searchDefaultValues || location.state });
  const searchParamState = formSearchObj.watch();
  const { handleSubmit } = formSearchObj;
  const { setSelectedRowKeys } = useTable();

  const {
    dataSource: dataClaimFull,
    loading: loadingClaimFull,
    onFetchFull: OnFetchClaimFull,
  } = useGetClaimFull({ handleSubmit: formSearchObj.handleSubmit });

  const {
    loading: loadingClaimDate,
    onFetch,
    data: dataClaimDate,
  } = useGetClaimDate({ setSelectedRowKeys, searchParamState });

  const { mutate: onSubmitApproveClaim, loading: isLoadingApproveClaim } = useApproveClaim({
    selectedRowKeys,
    onSuccessCallback: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
    },
  });

  const { mutate: onSubmitDowload, loading: isLoadingDownload } = useDownloadShipment({
    selectedRowKeys,
  });

  const onSearchByField = (values) => {
    if (values.search) {
      setSearchType('search');
      OnFetchClaimFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onFetch(values);
    }
  };

  const formSearch = SEARCH_FORM({ onEnter: formSearchObj.handleSubmit(onSearchByField) });

  // สร้างแถว Excel จาก exportHeaders โดยตรง คอลัมน์ที่แบรนด์นี้ไม่มีข้อมูลจะเว้นว่าง
  const transformDataForExcel = (data = []) =>
    (data ?? []).map((item) =>
      Object.fromEntries(
        exportHeaders.map(({ dataIndex }) => [
          dataIndex,
          exportBlankFields.includes(dataIndex) ? '' : item?.[dataIndex] ?? '',
        ]),
      ),
    );

  const handleSubmitApproveClaim = () => {
    onSubmitApproveClaim();
  };

  const handleSubmitDowmloadShipment = () => {
    onSubmitDowload(selectedRowKeys);
  };

  const onModalProcessStatus = (record) => {
    setClaimData(record);
    onToggleProcessStatus({ defaultValues: record });
  };

  const onOpenTracking = (record) => {
    setClaimData(record);
    onToggleTracking({ defaultValues: record });
  };

  const onOpenLineMessage = (record) => {
    setClaimData(record);
    onToggleLine({ defaultValues: record });
  };

  const onOpenRemarkMessage = (record) => {
    setClaimData(record);
    onToggleRemark({ defaultValues: record });
  };

  const onOpenClaimView = (record) => {
    const url = `${ROUTES_PATH.ROUTE_CLAIM_VIEW.PATH}?code=${record.claimCode}`;
    window.open(url, '_blank');
  };

  const onOpenClaimEdit = (record) => {
    const url = `${ROUTES_PATH.ROUTE_CLAIM_VIEW.PATH}?code=${record.claimCode}`;
    window.open(url, '_blank');
  };

  const gotoClaimAdd = useCallback(() => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_CLAIM_ADD.PATH });
  }, []);

  useEffect(() => {
    if (location.state && isInitialFetch) {
      formSearchObj.handleSubmit(onFetch)();
      setIsInitialFetch(false);
    } else {
      onFetch(searchDefaultValues);
    }
  }, [location.state, isInitialFetch]);

  return {
    transformDataForExcel,
    onSearchByField,
    formSearch,
    formSearchObj,
    dataClaimFull,
    loadingClaimFull,
    onFetch,
    dataClaimDate,
    loadingClaimDate,
    setSelectedRowKeys,
    handleSubmit,
    searchType,
    searchDefaultValues,
    handleSubmitApproveClaim,
    selectedRowKeys,
    isLoadingApproveClaim,
    handleSubmitDowmloadShipment,
    isLoadingDownload,
    openProcessStatus,
    onToggleProcessStatus,
    claimData,
    onModalProcessStatus,
    onFetch,
    openTracking,
    onToggleTracking,
    onOpenTracking,
    onToggleLine,
    openLine,
    onOpenLineMessage,
    openRemark,
    onToggleRemark,
    onOpenRemarkMessage,
    gotoClaimAdd,
    onOpenClaimView,
    onOpenClaimEdit,
  };
};
